// extracted by mini-css-extract-plugin
export default {"collapse":"Collapse_collapse__ZM7LY","dark":"Collapse_dark__1ZfrT"};